import {useEffect, useState} from 'react';
import {cartAPI} from "../../api/api";

export default function useCart() {

    const initCartModel = {
        cart: {
            BaseOrder: [],
            Stocks: [],
            DiscountModel:{
                DiscountPercent: 0,
                DiscountCondition: 0,
            }
        }
    }

    const getCart = () => {
        const cart = localStorage.getItem('cart');
        if(!cart){
            return JSON.stringify(initCartModel.cart);
        }
        return cart
    };

    const setInitCart = () => {
        (async () => {
            const {data} = await cartAPI.getCart();
            try {
                const cart = JSON.parse(data).cart
                localStorage.setItem('cart', JSON.stringify(cart));
                setCart(JSON.stringify(cart));
            }
            catch{
                localStorage.removeItem('cart')
                setCart(null);
            }
            console.log('Cart has been set')
        })();
    }

    const [cart, setCart] = useState(getCart());

    useEffect(() => {
        setInitCart()
    }, [cart])


    const addProductToBaseOrder = async (product) => {
        const cart = JSON.parse(getCart());
        const baseOrder = cart.BaseOrder;

        const productToAdd = { ...product };

        let isProductInCart = false;

        for (const item of baseOrder) {
            if (item.id === productToAdd.id) {
                item.count = (item.count || 1) + 1; // Increment count by 1 if it exists, otherwise set to 1
                item.calcPrice = parseFloat(item.count * item.priceList[0].UoMPrice);
                isProductInCart = true;
                break;
            }
        }

        if (!isProductInCart) {
            productToAdd.count = 1;
            baseOrder.push(productToAdd);
        }

        cart.BaseOrder = baseOrder;
        const resp = cart;

        
        const {data} = await cartAPI.setCart(resp);

        const result = JSON.parse(data);
        if(result.isSucccess)
        {
            setInitCart();
            return result;
        }
        return result;
    }

    const updateBaseOrderItem = async(product) => {
        const cart = JSON.parse(getCart())

        const baseOrder = cart.BaseOrder;

        const productToUpdate = { ...product };

        let resp = [];
        if (baseOrder !== null) {
            resp = baseOrder.reduce(function (filtered, option) {
                if (option.id !== product.id) {
                    filtered.push(option);
                } else {
                    option.priceListIndex = product.priceListIndex;
                    option.count = product.count;
                    option.calcPrice = product.calcPrice;
                    filtered.push(option);
                }
                return filtered;
            }, []);
        }
        resp.sort(function (a, b) {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });


        cart.BaseOrder = resp

        const {data} = await cartAPI.setCart(cart);
        const result = JSON.parse(data);
        if (result.isSucccess) {
            setInitCart()
            return result;
        }
        return result;
    }

    const deleteBaseOrderItem = async (productId) => {
        const cart = JSON.parse(getCart());
        const baseOrder = cart.BaseOrder;

        let resp = baseOrder.reduce(function (filtered, option) {
            if (option.id !== productId) {
                filtered.push(option);
            }
            return filtered;
        }, []);

        cart.BaseOrder = resp;

        const {data} = await cartAPI.setCart(cart);

        const result = JSON.parse(data);
        if (result.isSucccess) {
            //localStorage.setItem('cart', JSON.stringify(resp));
            //setCart(resp.toString());
            setInitCart();
            return result;
        }
        return result;
    }

    const addStockProductToCart = async (product, stockId, stockName) => {
        const cart = JSON.parse(getCart());
        const stockList = cart.Stocks;
        const productToAdd = { ...product };
        
        const foundStock = stockList.find(stock => stock.Id === stockId);
        if (foundStock) {
            // Поиск продукта в акции по productId
            const foundProduct = foundStock.ProductList.find(p => p.id === productToAdd.id);
        
            if (foundProduct) {
              // Если продукт уже есть в акции, увеличиваем count на 1
              foundProduct.count += 1;
            } else {
              // Если продукта нет в акции, добавляем его в список продуктов акции
              foundStock.ProductList.push(productToAdd);
            }
        }
        else {
            // Если акции нет в корзине, добавляем её в список акций
            stockList.push({
              Id: stockId,
              Name: stockName,
              ProductList: [
                productToAdd
              ],
            });
        }

        //отправляем на сервак
        cart.Stocks = stockList;
        const {data} = await cartAPI.setCart(cart);

        const result = JSON.parse(data);
        if(result.isSucccess)
        {
            setInitCart();
            return result;
        }
        return result;
    }

    const addStockProductSetToCart = async (stockId, stockName, setId) => {
        const cart = JSON.parse(getCart());
        const stockList = cart.Stocks;
        console.log('stockList before:', stockList)

        const foundStock = stockList.find(stock => stock.Id === stockId);

        if (foundStock) {
            // Поиск комплекта по  setId
            const foundSet = foundStock.ProductSetList.find(p => p.id === setId);
        
            if (foundSet) {
              // Если продукт уже есть в акции, увеличиваем count на 1
              foundSet.count += 1;
            } else {
              // Если продукта нет в акции, добавляем его в список продуктов акции
              foundStock.ProductSetList.push({id:setId, count: 1 });
            }
        }
        else {
            // Если акции нет в корзине, добавляем её в список акций
            stockList.push({
              Id: stockId,
              Name: stockName,
              ProductSetList: [
                { id: setId, count: 1 }
              ]
            });
        }

        debugger
        //отправляем на сервак
        const {data} = await cartAPI.setCart(cart);

        const result = JSON.parse(data);
        if(result.isSucccess)
        {
            setInitCart();
            return result;
        }
        return result;

    }

    const updateStockItem = async (product, stockId) => {
        const cart = JSON.parse(getCart());
        const stockList = cart.Stocks;

        const foundStock = stockList.find(stock => stock.Id === stockId);
      
        if (foundStock) {
          const foundProduct = foundStock.ProductList.find(p => p.id === product.id);
      
          if (foundProduct) {
            // Обновляем значение count на новое
            foundProduct.count = product.count;
          }
        }

        //отправляем на сервак
        cart.Stocks = stockList;
        const {data} = await cartAPI.setCart(cart);

        const result = JSON.parse(data);
        if(result.isSucccess)
        {
            setInitCart();
            return result;
        }
        return result;
    };

    const updateStockSetItem = async(setItem, stockId, count) => {
        const cart = JSON.parse(getCart());
        const stockList = cart.Stocks;

        const foundStock = stockList.find(stock => stock.Id === stockId);

        if (foundStock) {
            // Поиск комплекта по  setId
            const foundSet = foundStock.ProductSetList.find(p => p.id === setItem.id);

            if (foundSet) {
                // Если продукт уже есть в акции, увеличиваем count на 1
                foundSet.count = count;
            }
            else{
                return {
                    isSucccess: false,
                    message: 'Помилка відправки кошика на сервер. Не знайдено комплект в акції.',
                    data: null
                }
            }

        }
        else{
            return {
                isSucccess: false,
                message: 'Помилка відправки кошика на сервер. Не знайдено акцію.',
                data: null
            }
        }

        //отправляем на сервак
        const {data} = await cartAPI.setCart(cart);

        const result = JSON.parse(data);
        if(result.isSucccess)
        {
            setInitCart();
            return result;
        }
        return result;
  
    }

    const removeStockItemFromCart = async(productId, stockId) => {
        const cart = JSON.parse(getCart());
        const stockList = cart.Stocks;

        const foundStockIndex = stockList.findIndex(stock => stock.Id === stockId);

        if (foundStockIndex !== -1) {
          const foundStock = stockList[foundStockIndex];
          const foundProductIndex = foundStock.ProductList.findIndex(p => p.id === productId);
      
          if (foundProductIndex !== -1) {
            foundStock.ProductList.splice(foundProductIndex, 1);
      
            // Если список продуктов акции стал пустым, удаляем акцию
            if (foundStock.ProductList.length === 0) {
              stockList.splice(foundStockIndex, 1);
            }
          }
        }

        //отправляем на сервак
        const {data} = await cartAPI.setCart(cart);

        const result = JSON.parse(data);
        if(result.isSucccess)
        {
            setInitCart();
            return result;
        }
        return result;
    }

    const removeStockSetItemFromCart = async(stockId, setId) => {
        const cart = JSON.parse(getCart());
        const stockList = cart.Stocks;

        const foundStockIndex = stockList.findIndex(stock => stock.Id === stockId);

        if (foundStockIndex !== -1) {
            const foundStock = stockList[foundStockIndex];
            const foundSetItemIndex = foundStock.ProductSetList.findIndex(p => p.id === setId);

            if (foundSetItemIndex !== -1) {
                foundStock.ProductSetList.splice(foundSetItemIndex, 1);
          
                // Если список продуктов акции стал пустым, удаляем акцию
                if (foundStock.ProductSetList.length === 0) {
                  stockList.splice(foundStockIndex, 1);
                }
            }
        }

        //отправляем на сервак
        cart.Stocks = stockList;
        const {data} = await cartAPI.setCart(cart);

        const result = JSON.parse(data);
        if(result.isSucccess)
        {
            setInitCart();
            return result;
        }
        return result;
    }

    const addToCart = async (product) => {
        const cart = JSON.parse(getCart());
        const productToAdd = { ...product };

        let isProductInCart = false;

        for (const item of cart) {
            if (item.id === productToAdd.id) {
                item.count = (item.count || 1) + 1; // Increment count by 1 if it exists, otherwise set to 1
                isProductInCart = true;
                break;
            }
        }

        if (!isProductInCart) {
            productToAdd.count = 1;
            cart.push(productToAdd);
        }

        const resp = cart;
        //отправка корзины на сервак. если успех, то просто заносим в состояние то, что слали в бэк
        const {data} = await cartAPI.setCart(resp);

        const result = JSON.parse(data);
        if(result.isSucccess)
        {
            setInitCart();
            return result;
        }
        return result;
    };

    const clearCart = async () => {
        const cart = initCartModel;

        //отправка корзины на сервак. если успех, то просто заносим в состояние то, что слали в бэк
        const {data} = await cartAPI.setCart(cart);

        const result = JSON.parse(data);
        if (result.isSucccess) {
            setInitCart();
            return result;
        }
        return result;
    }

    const updateCartItem = async (product) => {
        const cart = JSON.parse(getCart())
        let resp = [];
        if (cart !== null) {
            resp = cart.reduce(function (filtered, option) {
                if (option.id !== product.id) {
                    filtered.push(option);
                } else {
                    option.priceListIndex = product.priceListIndex;
                    option.count = product.count;
                    option.calcPrice = product.calcPrice;
                    filtered.push(option);
                }
                return filtered;
            }, []);
        }
        resp.sort(function (a, b) {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });

        const {data} = await cartAPI.setCart(resp);
        const result = JSON.parse(data);
        if (result.isSucccess) {
            setInitCart()
            return result;
        }
        return result;
    }

    const deleteFromCart = async (productId) => {
        const cart = JSON.parse(getCart());

        let resp = cart.reduce(function (filtered, option) {
            if (option.id !== productId) {
                filtered.push(option);
            }
            return filtered;
        }, []);

        const {data} = await cartAPI.setCart(resp);

        const result = JSON.parse(data);
        if (result.isSucccess) {
            setInitCart();
            return result;
        }
        return result;
    }


    return {
        addStockProductToCart: addStockProductToCart,
        addStockProductSetToCart: addStockProductSetToCart,
        addProductToBaseOrder: addProductToBaseOrder,
        updateBaseOrderItem: updateBaseOrderItem,
        updateStockItem: updateStockItem,
        updateStockSetItem: updateStockSetItem,
        deleteBaseOrderItem: deleteBaseOrderItem,
        removeStockItemFromCart: removeStockItemFromCart,
        removeStockSetItemFromCart: removeStockSetItemFromCart,
        deleteFromCart: deleteFromCart,
        updateCartItem: updateCartItem,
        getCart: getCart,
        clearCart: clearCart,
        setInitCart: setInitCart,
        cart
    }
}